"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var NoMetaFound = /** @class */ (function (_super) {
    __extends(NoMetaFound, _super);
    function NoMetaFound() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoMetaFound;
}(Error));
exports.default = (function (element, propName) {
    var prop = element.querySelector("[itemprop=\"" + propName + "\"]");
    try {
        if (prop === null) {
            throw new NoMetaFound('Prop not found');
        }
        var result = null;
        if (prop.tagName === 'META') {
            // Parametry przechowywane w meta-tagach
            var content = prop.attributes.getNamedItem('content');
            if (content === null) {
                throw new NoMetaFound('Meta tag has no content attribute');
            }
            result = content.value.trim();
        }
        else if (prop.tagName === 'A' || prop.tagName === 'LINK') {
            // Parametry przechowywane w tagach a/link
            var href = prop.attributes.getNamedItem('href');
            if (href === null) {
                throw new NoMetaFound('Meta tag has no href attribute');
            }
            result = href.value.trim();
        }
        else {
            // Parametry dodane do istniejących elementów
            if (prop.textContent === null) {
                throw new NoMetaFound('Tag has no text content');
            }
            result = prop.textContent.trim();
        }
        return result;
    }
    catch (e) {
        return null;
    }
});
